import React, { useState, useEffect } from "react";
import "./ScopeDescription.css";
import { useAuthFetch } from "../hooks/useAuthFetch";

// Edit icon component (same as ProjectInfo)
const PencilIcon = (props) => (
  <svg className={`w-4 h-4 ${props.className || ""}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
  </svg>
);

function ScopeDescription({ scopeDescription, idProject }) {
  const { authFetch } = useAuthFetch();
  const [modalOpen, setModalOpen] = useState(false);
  const [value, setValue] = useState(scopeDescription || "");
  const [displayedScope, setDisplayedScope] = useState(scopeDescription || "-");
  const [loading, setLoading] = useState(false);

  console.log("ScopeDescription props:", { scopeDescription, idProject });

  // Keep local states in sync if props change externally
  useEffect(() => {
    setDisplayedScope(scopeDescription || "-");
    setValue(scopeDescription || "");
  }, [scopeDescription]);

  // BASE URL
  const BASE =
    (process.env.REACT_APP_BACKEND_BASEURL || "http://localhost:3000").replace(
      /\/+$/,
      ""
    );

  const saveScope = async () => {
    console.log("Saving scope:", idProject);
    if (!idProject) return;
    setLoading(true);
    try {
      const res = await authFetch(
        `${BASE}/api/salesforce/opportunity/${idProject}/scope`,
        {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ project_scope: value }),
        }
      );
      if (!res.ok) throw new Error(`PUT failed: ${res.status}`);
      const json = await res.json();
      console.log("Saved:", json);

      // ✅ Update UI immediately
      setDisplayedScope(value);

      setModalOpen(false);
    } catch (e) {
      console.error("ScopeDescription save error:", e);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="scope-description-container mt-5 relative">
      {/* Header with edit btn */}
      <div className="scope-description-header flex items-center justify-between">
        <h2 className="scope-description-title">Scope Description</h2>
        <button 
          onClick={() => setModalOpen(true)} 
          className="text-gray-400 hover:text-gray-600 p-1"
          title="Edit Scope"
        >
          <PencilIcon />
        </button>
      </div>

      {/* Content */}
      <div className="scope-description-content">
        <div className="scope-description-text">
          {displayedScope}
        </div>
      </div>

      {/* Modal */}
      {modalOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
          <div className="bg-white rounded-lg p-6 w-[680px] max-w-[94vw]">
            <h3 className="text-lg font-semibold mb-4">Edit Scope Description</h3>
            <textarea
              className="border rounded w-full px-3 py-2 text-sm min-h-[120px]"
              value={value}
              onChange={(e) => setValue(e.target.value)}
            />
            <div className="flex justify-end gap-3 mt-6">
              <button
                onClick={() => setModalOpen(false)}
                className="px-4 py-2 border rounded text-sm"
                disabled={loading}
              >
                Cancel
              </button>
              <button
                onClick={saveScope}
                className="px-5 py-2 bg-red-600 text-white rounded text-sm"
                disabled={loading}
              >
                {loading ? "Saving..." : "Save"}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default ScopeDescription;
